import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PostImage } from "../utils/apiCall";
import { t } from "i18next";
import { Dialog } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { defaultConfig } from "../config";

const ApiLoder = () => {
  return (
    <>
      <div className="spinner_overlay"></div>
      <div className="spinner-box">
        <img
          src="/image/loder.gif"
          alt=""
          className="loading-icon"
          loading="lazy"
        />
      </div>
    </>
  );
};

const SuccessMessage = (message) => {
  setTimeout(() => {
    toast.success(
      <div className="custom-toast">
        <span className="toast-check">✔</span>
        <span className="toast-text">{message}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        hideProgressBar: true,
        pauseOnHover: false,
        draggable: false,
        className: "toast-wrapper",
        bodyClassName: "toast-body",
          icon: false,     
          
      }
    );
  }, 10);
};
const ErrorMessage = (message) => {
  toast.error(
    <div className="custom-toast error-toast">
      <span className="toast-check error-icon">✕</span>
      <span className="toast-text">{message}</span>
    </div>,
    {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      hideProgressBar: true,
      pauseOnHover: false,
      draggable: false,
      icon: false,               // ✅ hide default toast icon
      className: "toast-wrapper",
      bodyClassName: "toast-body",
    }
  );
};

const CommonUploadImage = async (e, handleonchange, allowedFileTypes) => {
  let file = e?.target?.files[0];
  let name = e?.target?.name;
  if (
    allowedFileTypes.includes(file?.type) ||
    allowedFileTypes.includes(file?.name?.split(".").reverse()[0])
  ) {
    const path = await PostImage(file);
    if (path?.length > 0) {
      handleonchange((extra) => ({ ...extra, [name]: path[0] }));
    } else {
      handleonchange((extra) => ({ ...extra, [name]: "" }));
    }
    e.target.value = null;
  } else {
    ErrorMessage("Invalid file Formate");
    handleonchange((extra) => ({ ...extra, [name]: "" }));
    e.target.value = null;
    return false;
  }
};

const CustomMessages = {
  required: t("required_field"),
  email: t("email_field"),
  min: t("min_field"),
  max: t("max_field"),
  numeric: t("numeric_field"),
  alpha_num: t("alpha_num_field"),
  alpha_num_space: t("alpha_num_space_field"),
};

function SubmitButton({ onClick, disabled, text }) {
  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className="btn blue-btn"
    >
      {text}
      {disabled && (
        <i className="fa fa-spinner fa-spin" style={{ marginLeft: "10px" }}></i>
      )}
    </button>
  );
}

const Delete = ({ open, handleClose, handleDelete, title, id, loder }) => {
  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth={"xs"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body logout-popup text-center">
              <span className="mx-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={48}
                  height={48}
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.592 4.4881C25.306 3.6521 28 6.8441 28 10.0001V38.0001C28 41.1561 25.306 44.3481 21.592 43.5121C12.668 41.5041 6 33.5321 6 24.0001C6 14.4681 12.668 6.4961 21.592 4.4881ZM32.586 16.5861C32.9611 16.2112 33.4697 16.0005 34 16.0005C34.5303 16.0005 35.0389 16.2112 35.414 16.5861L41.414 22.5861C41.7889 22.9612 41.9996 23.4698 41.9996 24.0001C41.9996 24.5304 41.7889 25.039 41.414 25.4141L35.414 31.4141C35.0368 31.7784 34.5316 31.98 34.0072 31.9754C33.4828 31.9709 32.9812 31.7606 32.6104 31.3897C32.2395 31.0189 32.0292 30.5173 32.0247 29.9929C32.0201 29.4685 32.2217 28.9633 32.586 28.5861L35.172 26.0001H18C17.4696 26.0001 16.9609 25.7894 16.5858 25.4143C16.2107 25.0392 16 24.5305 16 24.0001C16 23.4697 16.2107 22.961 16.5858 22.5859C16.9609 22.2108 17.4696 22.0001 18 22.0001H35.172L32.586 19.4141C32.2111 19.039 32.0004 18.5304 32.0004 18.0001C32.0004 17.4698 32.2111 16.9612 32.586 16.5861Z"
                    fill="white"
                  />
                </svg>
              </span>
              <h3> Delete</h3>
              <p>
                Are your sure you want to delete{" "}
                <strong className="stongtag">{title}</strong> ?
              </p>
              <div className="save_btn">
                <button
                  type="button"
                  className="btn border-btn me-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn blue-btn"
                  disabled={loder}
                  onClick={() => {
                    handleDelete(id);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

function SelectBoxLoader() {
  return (
    <div
      className="spinner-border custom_spiner text-danger spinner-border-sm"
      role="status"
    ></div>
  );
}

function BackButton({ link }) {
  const navigate = useNavigate();
  return (
    <div className="back-option mb-2 " onClick={(()=>navigate(-1))} style={{cursor:"pointer"}}>
      <div className="d-flex align-items-center">
        <img src="/image/back.svg" className="me-1" alt="" loading="lazy" />{" "}
        Back
      </div>
    </div>
  );
}

const PreviewFiles = ({ file, isdelete = false, handleImageDelelet }) => {
  return (
    <>
      <div className="d-flex gap-2 flex-wrap">
        {file &&
          file.length > 0 &&
          file.map((val, i) => {
            const fileExtension = val.split(".").pop().toLowerCase();
            const isImage = ["jpeg", "jpg", "png"].includes(fileExtension);
            return (
              <React.Fragment key={i}>
                <Link
                  to={val.trim()}
                  target="_blank"
                  className="d-block attchment-file tax_document"
                >
                  {isImage ? (
                    <img
                      src={val}
                      alt={`Preview ${val}`}
                      loading="lazy"
                      height={30}
                      width={30}
                    />
                  ) : (
                    <img
                      src="/image/file.svg"
                      alt="File preview"
                      loading="lazy"
                    />
                  )}
                </Link>
                {isdelete && (
                  <i
                    className="fa fa-times deleteimage"
                    onClick={() => handleImageDelelet(i)}
                  ></i>
                )}
              </React.Fragment>
            );
          })}
      </div>
    </>
  );
};

const PreviewFiles2 = ({ file = [], isdelete = false, handleImageDelelet,image="",type }) => {
  const fallbackIcon = "/image/file.svg";

  return (
    <div className="d-flex gap-2 flex-wrap">
      {file.length > 0 &&
        file.map((val, i) => {
          const fileType = val.type || "";
          const isImage = fileType.startsWith("image/");

          const previewURL = !image?`${defaultConfig.imageUrl}/public/images/${type}/`+val:URL.createObjectURL(val);

          return (
            <div key={i} className="position-relative">
              <a
                href={previewURL}
                target="_blank"
                rel="noopener noreferrer"
                className="d-block attchment-file tax_document"
              >
                <img
                  src={isImage ? previewURL : fallbackIcon}
                  alt={`Preview ${i + 1}`}
                  loading="lazy"
                  height={30}
                  width={30}
                />
              </a>
              {isdelete && (
                <i
                  className="fa fa-times deleteimage"
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                  onClick={() => handleImageDelelet(i)}
                  title="Remove"
                ></i>
              )}
            </div>
          );
        })}
    </div>
  );
};

const PreviewFiles3 = ({ file = [], isdelete = false, handleImageDelelet}) => {
  const fallbackIcon = "/image/file.svg";

  return (
    <div className="d-flex gap-2 flex-wrap">
      {file.length > 0 &&
        file.map((val, i) => {
          const fileType = val.type || "";
          const isImage = fileType.startsWith("image/");

          const previewURL = URL.createObjectURL(val);

          return (
            <div key={i} className="position-relative">
              <a
                href={previewURL}
                target="_blank"
                rel="noopener noreferrer"
                className="d-block attchment-file tax_document"
              >
                <img
                  src={isImage ? previewURL : fallbackIcon}
                  alt={`Preview ${i + 1}`}
                  loading="lazy"
                  height={30}
                  width={30}
                />
              </a>
              {isdelete && (
                <i
                  className="fa fa-times deleteimage"
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                  onClick={() => handleImageDelelet(i)}
                  title="Remove"
                ></i>
              )}
            </div>
          );
        })}
    </div>
  );
};


const PreviewFiles4 = ({ file = [], isdelete = false, handleImageDelelet }) => {
  const fallbackIcon = "/image/file.svg";

  const getPreviewData = (val) => {
    let isImage = false;
    let name = "";
    let url = "";
    
    if (val instanceof File) {
      isImage = val.type.startsWith("image/");
      name = val.name;
      url = URL.createObjectURL(val);
    } else {
      // From API
      const extension = val.name?.split(".").pop()?.toLowerCase();
      isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
      name = val.name;
      url = val.url;
    }

    return { isImage, name, url };
  };

  return (
    <div className="d-flex gap-2 flex-wrap">
      {file.length > 0 &&
        file.map((val, i) => {
          const { isImage, name, url } = getPreviewData(val);

          return (
            <div key={i} className="position-relative text-center" style={{ width: 80 }}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="d-block attchment-file tax_document"
              >
                <img
                  src={isImage ? url : fallbackIcon}
                  alt={`Preview ${name}`}
                  loading="lazy"
                  height={30}
                  width={30}
                  className="mt-2"
                />
                <div
                  style={{
                    fontSize: "10px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                    paddingLeft:"4px"
                  }}
                  title={name}
                >
                  {name}
                </div>
              </a>
              {isdelete && (
                <i
                  className="fa fa-times deleteimage"
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                  onClick={() => handleImageDelelet(i)}
                  title="Remove"
                ></i>
              )}
            </div>
          );
        })}
    </div>
  );
};


const PreviewFiles5 = ({ file = [] }) => {
  return (
    <div className="d-flex gap-2 flex-wrap">
      {file.map((doc, index) => {
        const fileUrl = doc.document_url || doc.admin_document_url;
        const fileName = doc.document_name || doc.admin_document_name;
        const fileExt = fileName.split('.').pop().toLowerCase();

        // Supported image extensions
        const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

        const isImage = imageTypes.includes(fileExt);
        const previewSrc = isImage ? fileUrl : '/image/file.svg';

        return (
          <div key={doc.id || index} className="position-relative text-center" style={{ width: 80 }}>
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="d-block attchment-file tax_document"
            >
              <img
                src={previewSrc}
                alt={`Preview ${fileName}`}
                loading="lazy"
                height={30}
                width={30}
                className="mt-2"
              />
              <div
                title={fileName}
                style={{
                  fontSize: 10,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  paddingLeft: 4,
                }}
              >
                {fileName}
              </div>
            </a>
            
          </div>
        );
      })}
    </div>
  );
};


export {
  ApiLoder,
  ErrorMessage,
  SuccessMessage,
  CommonUploadImage,
  CustomMessages,
  SubmitButton,
  Delete,
  SelectBoxLoader,
  BackButton,
  PreviewFiles,
  PreviewFiles2,
  PreviewFiles3,
  PreviewFiles4,
  PreviewFiles5
};
